import { render, staticRenderFns } from "./CollectPaymentModal.vue?vue&type=template&id=4744dbc7&scoped=true"
import script from "./CollectPaymentModal.vue?vue&type=script&lang=js"
export * from "./CollectPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./CollectPaymentModal.vue?vue&type=style&index=0&id=4744dbc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4744dbc7",
  null
  
)

export default component.exports